import React from 'react';
import {mcClear, mcSearch} from '@mc/react-ui-icons';
import {Button, Icon, StringInput} from '@mc/ui-v4';

type Props = {
    value: string;
    disabled?: boolean;
    onChange: (text: string) => void;
    /** Okamžité vyhledání (Enter) – jinak se hledá automaticky po krátkém debounce. */
    onSearch: () => void;
    /** Smazání zadaného textu i vyhledaných výsledků. */
    onClear: () => void;
    /** Získání focusu do pole (mobil: vytažení bottom sheetu). */
    onFocus?: () => void;
};

/**
 * Vyhledávací pole panelu – ui-v4 StringInput s ikonou hledání vlevo a tlačítkem pro smazání vpravo.
 * Vyhledává se automaticky po debounce (viz useSearchPanelSearch), proto tu není tlačítko „Vyhledat".
 */
export const SearchPanelInput: React.FC<Props> = ({value, disabled, onChange, onSearch, onClear, onFocus}) => {
    return (
        <StringInput
            className={'search-panel-input'}
            value={value}
            disabled={disabled}
            placeholder={'Hledat objekt nebo adresu'}
            leftElement={<Icon icon={mcSearch} intent={'secondary'} />}
            rightElement={value ? <Button style={'link'} noFocus icon={<Icon icon={mcClear} />} onClick={onClear} title={'Smazat'} /> : undefined}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
            onSearch={onSearch}
            onFocus={onFocus}
        />
    );
};
